import React, { useEffect, useState } from "react";
import logo from "../assets/logo.svg";
import googleIcon from "../assets/Google icon.svg";
import { Link, useNavigate } from "react-router-dom";

const Signup = () => {
  const [userRole, setUserRole] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const user = localStorage.getItem("userRole");
    setUserRole(user || ""); // Set default value if userRole is null
  }, []);

  const handleEmail = (e) => {
    setEmail(e.target.value);
  };

  const handlePassword = (e) => {
    setPassword(e.target.value);
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    localStorage.setItem(
      "formDetails",
      JSON.stringify({
        email: email,
        password: password,
        userRole,
      })
    );
    if (userRole === "student") {
      navigate("/create-student-account");
    } else if (userRole === "organization") {
      navigate("/create-company-account");
    } else {
      navigate("/register");
    }
  };
  return (
    <div className="flex items-center justify-center min-h-screen h-full custom-bg flex-col w-100 py-4">
      <div className="form-container w-fit bg-white md:px-[100px] px-[32px] xsm:m-2 xsm:max-m-[32px] py-[20px]">
        <img src={logo} className="mb-[24px]" alt="Logo" />
        <span className="custom-title mb-[14px]">Sign Up</span>
        <span className="custom-desc mb-[24px] max-w-[360px]">
          Sign up now to find your ideal internship and kickstart your career!
        </span>
        <form className="w-full" onSubmit={handleSubmit}>
          <section className="flex-col gap-[20px] flex">
            <div className="flex flex-col w-full">
              <label htmlFor="Email" className="form-label">
                Email
              </label>
              <input
                required
                type="email"
                value={email}
                onChange={handleEmail}
                className="custom-form"
                placeholder="Enter your email"
              />
            </div>
            <div className="flex flex-col w-full">
              <label htmlFor="Password" className="form-label">
                Password
              </label>
              <input
                required
                type="password"
                value={password}
                onChange={handlePassword}
                className="custom-form"
                placeholder="Enter your password"
              />
            </div>
            <Link
              to="/reset"
              className="custom-forgot items-end justify-end flex"
            >
              Forgot Password ?
            </Link>
            <div className="text-warning">
              You want to sign up as a{" "}
              <Link to="/register" className="text-success">
                {" "}
                {userRole === "student" ? "candidate" : userRole}
                {/* {userRole} */}
              </Link>
            </div>
          </section>
          <button
            type="submit"
            className="btn bg-[#049645] hover:bg-[#1E4929] text-white w-full font-bold text-lg my-[24px]"
          >
            Create Account
          </button>
          <button className="w-full flex items-center justify-center gap-2 border p-2 border-[#D0D5DD] rounded-[8px]">
            <img src={googleIcon} alt="Google Icon" />
            <span>Sign Up with Google</span>
          </button>
        </form>
        <section className="flex gap-1 items-center justify-center my-4">
          <span>Have an account?</span>
          <Link to="/login" className="custom-forgot">
            Login
          </Link>
        </section>
      </div>
    </div>
  );
};

export default Signup;
